import React, { useState } from 'react';
import { 
  PageHeader, 
  SectionCard, 
  DataTable, 
  StatusBadge 
} from '../../components/common';
import { theme } from '../../design/theme';

interface User {
  id: string;
  name: string;
  email: string;
  status: 'ACTIVE' | 'PENDING' | 'INACTIVE';
  role: 'USER' | 'ADMIN';
}

export const UserManagement: React.FC = () => {
  const [users, setUsers] = useState<User[]>([
    { id: '1', name: 'John Doe', email: 'john@acme.com', status: 'ACTIVE', role: 'USER' },
    { id: '2', name: 'Jane Smith', email: 'jane@acme.com', status: 'PENDING', role: 'USER' },
    { id: '3', name: 'Bob Wilson', email: 'bob@acme.com', status: 'ACTIVE', role: 'ADMIN' },
  ]);

  const handleApprove = (id: string) => {
    setUsers(users.map(u => u.id === id ? { ...u, status: 'ACTIVE' } : u));
  };

  const handleRemove = (id: string) => {
    if (window.confirm('Are you sure you want to remove this user?')) {
      setUsers(users.filter(u => u.id !== id));
    }
  };

  const columns = [
    { header: 'NAME', accessor: 'name' as const },
    { header: 'EMAIL', accessor: 'email' as const },
    { header: 'ROLE', accessor: 'role' as const },
    { 
      header: 'STATUS', 
      accessor: 'status' as const,
      render: (status: string) => {
        const typeMap: any = {
          'ACTIVE': 'HEALTHY',
          'PENDING': 'RISK',
          'INACTIVE': 'CRITICAL'
        };
        return <StatusBadge status={typeMap[status] || 'EXPIRED'} label={status} />;
      }
    },
    {
      header: 'ACTIONS',
      accessor: 'id' as const,
      render: (_: string, row: User) => (
        <div style={{ display: 'flex', gap: theme.spacing.sm }}>
          {row.status === 'PENDING' && (
            <button 
              onClick={() => handleApprove(row.id)} 
              style={{ backgroundColor: theme.colors.healthy.main, color: '#FFFFFF', border: 'none', padding: '4px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}
            >
              Approve
            </button>
          )}
          <button 
            onClick={() => handleRemove(row.id)} 
            style={{ backgroundColor: 'transparent', color: theme.colors.critical.main, border: `1px solid ${theme.colors.critical.main}`, padding: '4px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}
          >
            Remove
          </button>
        </div>
      )
    }
  ];

  return (
    <div>
      <PageHeader 
        title="User Management" 
        subtitle="Manage your company's employees and their access requests."
      />

      <SectionCard title="Employee Directory">
        <DataTable columns={columns} data={users} />
      </SectionCard>
    </div>
  );
};
